import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/** UI literals only. Never pass client names, message bodies or saved view names. */
export function useAdvisorCopy() {
  const { t } = useTranslation('advisor');
  return useCallback(
    (source: string, values: Record<string, string | number> = {}) =>
      t(source, {
        ...values,
        defaultValue: source,
        keySeparator: false,
        nsSeparator: false,
      }),
    [t],
  );
}

export function useAdvisorLocale() {
  const { i18n } = useTranslation();
  return i18n.resolvedLanguage?.startsWith('fr') ? 'fr-CA' : 'en-US';
}
